module.exports = __webpack_public_path__ + "static/media/americanExpress.bb61070d.svg";